// Objetivo: Contiene la sección de dirección del oferente en el formulario de indicadores
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';

export const DireccionReceptor = ({
  errors,
  handleChange,
  isSubmitting,
  setFieldTouched,
  setFieldValue,
  touched,
  handleBlur,
  values
}) => {
  return (
    <>
      <SelectorDireccionContainer
        values={values}
        errors={errors}
        touched={touched}
        onChange={handleChange}
        handleBlur={handleBlur}
        setFieldTouched={setFieldTouched}
        setFieldValue={setFieldValue}
        isSubmitting={isSubmitting}
        nameRegion="regionDemandante"
        nameComuna="comunaDemandante"
        nameNombreVia="nombreViaDemandante"
        subtitle=""
        className="grid grid-cols-12 gap-4 "
      />
    </>
  );
};

// * Demandante (deprecado) -> Receptor
